import './Loading.scss';

export default function Loading() {
    return (
        <div className="lds-wrapper">
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}